import { Route, Routes } from 'react-router-dom';
import { CompanyShareCapital } from './ShareCapital';
import { ShareholderOverview } from './reports/ShareholderOverview';
import { TransactionsRoutes } from './transactions/Transactions.root';
import { FullReport } from './reports/full-report/FullReport';
import { IndividualReport } from './reports/individual-report/IndividualReport';
import { TransactionReport } from './reports/Transaction';
import { ShareCertificates } from './share-certificates/ShareCertificates';

export const ShareRegister = () => {
  return (
    <Routes>
      <Route path="share-capital" element={<CompanyShareCapital />} />
      <Route path="overview" element={<ShareholderOverview />} />
      <Route path="transactions" element={<TransactionsRoutes />}>
        <Route path="*" element={<TransactionsRoutes />} />
      </Route>
      <Route path="full" element={<FullReport />} />
      <Route path="individual" element={<IndividualReport />} />
      <Route path="transaction" element={<TransactionReport />} />
      <Route path="share-certificates" element={<ShareCertificates />} />
    </Routes>
  );
};
